import { AuthorizationRequest, RedirectRequestHandler } from "@openid/appauth";
import { CLIENT_ID } from '@pv/constants';
import fetchAuthConfig from "@pv/auth/fetchAuthConfig";

const signIn = async (redirectUri, { state = {}, extras = {} }) => {
    const authConfig = await fetchAuthConfig();
    const authHandler = new RedirectRequestHandler();
    const authRequest = new AuthorizationRequest({
        client_id: CLIENT_ID,
        redirect_uri: redirectUri,
        scope: 'openid profile email plakat_verkauft',
        response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
        state: JSON.stringify(state),
        extras
    });
    authHandler.performAuthorizationRequest(authConfig, authRequest)
};

export default signIn;